import req from '@/api/request'

// 枚举
export const enumList = (enumName) => {
  return req().get(`/base/api/sys/enum/view?name=${enumName}`)
}

/**
 * 分类
 * @returns {*}
 */
export const categoryLists = (data) => {
  console.log(data)
  return req().get(`/base/api/shop/category/list?categoryType=${data.categoryType ? data.categoryType : 1}&menuType=${data.menuType ? data.menuType : ''}`)
}

/**
 * 用户收藏添加
 * @param data
 * @returns {*}
 */
export function collectionUserSave (data) {
  return req().post('/scm/auth/collection/user/save', data)
}

/**
 * 用户收藏删除
 * @param data
 * @returns {*}
 */
export function collectionUserDelete (data) {
  return req().delete('/scm/auth/collection/user/delete', { data })
}

/**
 * 获取平台信息
 * @returns {*}
 */
export function shopDataInfo (params) {
  return req().get('/base/api/shop/website/domain', { params })
}

export function shopAgreement () {
  return req().get('/base/api/shop/agreement')
}

// 教师入驻申请协议
export function teacherApplyAgreement () {
  return req().get('/base/api/shop/get/teacher/apply/agreement')
}

// 获取授权地址
export function getWxConfig (data) {
  return req().post('/base/api/wx/op/get/three/authorization/url', data)
}

// 绑定授权
export function bindAuthInfo (data) {
  return req().post('/base/api/wx/op/bind/authorization/info', data)
}

export function getWxAuthLoginUrl (data) {
  return req().post('/base/api/shop/user/get/wx/login/auth/url', data)
}

export function wxLogin (data) {
  return req().post('/base/api/shop/user/wx/authorized/login', data)
}

export function wxBinding (data) {
  return req().post('/base/api/shop/user/wx/authorized/bind', data)
}

export function checkPhoneExist (data) {
  return req().post('/base/api/shop/user/check/phone/exist', data)
}

export function dissociatedWechat () {
  return req().put('/base/auth/shop/user/unbind/wx')
}

export function bindingAuthWx (data) {
  return req().post('/base/auth/shop/user/bind/wx', data)
}

export function testDebug (data) {
  return req().post('/resource/api/article/adv/test', data)
}
// 获取图片base64
export function getImage2Base64 (url) {
  return req().post('/base/api/upload/encoded', { picUrl: url })
}
export function getImage2Base64Tow (url) {
  return req().post('/base/api/upload/encoded2', { picUrl: url })
}
// 获取加密公钥
export function publicKey () {
  return req().get('/base/api/shop/user/get/public/key')
}
